import _debounce from 'lodash/debounce';
import {addToCompareOnPage} from "./compare";

const formData = new FormData();
const formDataObj = {};
const addProductsToCartButton = $('#addProductsToCart');
const searchProductInput = $("#searchProducts");
const searchProductInputButton = $(".search-products-add");
const productAlreadyInListAlert = $("#productAlreadyInListAlert");
const compareContainer = document.querySelector('.product-compare-container');

$('#fastProductEntry').submit(function (event) {
    getRow();
    event.preventDefault()
});

function getRow() {

    const isProductCompare = document.body.contains(compareContainer);

    if (isProductCompare) {

        let productId = $('#searchProductsId').val();
        addToCompareOnPage(productId);

    } else {

        const matNo = $('#fastProductEntry input')[0].value;
        if ($('#fastProductEntryList .fast-product-entry-mat-no[value="' + matNo + '"]').length) {
            $('#matNoAlreadyEntered').show();
            return;
        }
        window.axios.get(window.config.urls.fastProductEntryRow.replace(':product:', matNo))
            .then(({data}) => {
                if (data.success) {

                    productAlreadyInListAlert.hide();

                    if (!formDataObj.hasOwnProperty(matNo)) {
                        formDataObj[data.id] = '';

                        const entry = $('#fastProductEntryRowTemplate').clone(true);
                        entry.data('productId', data.id)
                        entry.find('.fast-product-entry_mat-no').html(matNo);
                        entry.find('.fast-product-entry_product-quantity').attr('name', 'entries[' + data.id + ']');
                        entry.find('.fast-product-entry_image').html(data.image);
                        entry.find('.fast-product-entry_name').text(data.name);
                        entry.find('.fast-product-entry_price').text(data.price);
                        entry.find('.is-number-input__input').data('materialNumber', matNo);
                        entry.find('.vat-hint').toggleClass('d-none', !data.display_vat ?? false);
                        $('#fastProductEntryList').append(entry);
                        entry.show();
                        $('#fastProductEntryErrors').children().hide();
                        formData.append(`entries[${data.id}]`, JSON.stringify(1));
                    } else {
                        productAlreadyInListAlert.show();
                    }

                    setButtonState(Object.keys(formDataObj).length);
                }
            })
            .catch(() => {
                $('#matNoNotFound').show();
            });

    }

    // Clear input field and set focus
    searchProductInput.val('').focus();

    // Scroll to input field position
    searchProductInput[0].scrollIntoView();

}

function changeQuantity(item) {
    const productId = item.data('productId');
    window.axios.get(window.config.urls.fastProductEntryPrice.replace(':product:', productId), {
        params: {
            quantity: item.find('.is-number-input__input').val()
        }
    })
        .then(({data}) => {

            item.find('.fast-product-entry_product-quantity').val(data.quantity);
            item.find('.fast-product-entry_price').text(data.price);
            $(this).removeClass('is-invalid');
            let amount = item.find('.is-number-input__input').val();
            formData.append(`entries[${productId}]`, JSON.stringify(parseInt(amount)));
        })
        .catch(() => {
            $(this).addClass('is-invalid');
        });

}


$('#fastProductEntryRowTemplate .fast-product-entry_remove-item').click(function () {
    const number = $(this).closest('.is-cart-item').data('productId');

    formData.delete(`entries[${number}]`);
    delete formDataObj[number];

    setButtonState(Object.keys(formDataObj).length);
    $(this).closest('.is-cart-item').remove();
});

$('#fastProductEntryRowTemplate .is-number-input__input').change(_debounce(function () {
    const item = $(this).closest('.is-cart-item');
    changeQuantity(item);
}, 200));

const options = {
    url: function (phrase) {
        let url = new URL(searchProductInput.data('api'));

        url.searchParams.append('query', phrase);

        return url.toString();
    },
    getValue: "material_number",
    list: {
        onKeyEnterEvent: function () {
            getRow();
        },
        onSelectItemEvent: function () {
            $('#searchProductsId').val(searchProductInput.getSelectedItemData().id).trigger('change');
        },
        onClickEvent: function () {
            getRow();
        }
    },
    template: {
        type: "custom",
        method: function (value, item) {
            return `<span class="d-flex align-items-center">
                        <img class="eac-icon" src="${item.imagePath}" />
                        <span class="d-flex flex-column">
                            <span>${item.material_number}</span>
                            <small class="text-muted">${item.name}</small>
                        </span>
                    </span>`;
        }
    }
};

function addProductsToCart() {
    window.axios.post(window.config.urls.pushProducts, formData).then(({data: data}) => {
        $('#fpeAddToCardModal').find('.modal-body').html(data.template);
        $('#fpeAddToCardModal').modal('show');
    });
}

function setButtonState(length) {
    if (length > 0) {
        addProductsToCartButton.prop('disabled', false);
        return
    }
    addProductsToCartButton.prop('disabled', true);
}

searchProductInput.easyAutocomplete(options);

addProductsToCartButton.on('click', function () {
    addProductsToCart();
});

searchProductInputButton.on('click', function () {
    getRow();
});

searchProductInput.on('keyup', function (e) {
    if (e.target.value === '') {
        searchProductInputButton.prop('disabled', true);
    }
    searchProductInputButton.prop('disabled', false);
})
